module.exports = ".ck.ck-menu-bar{border:none;border-bottom:1px solid var(--ck-color-toolbar-border)}"